export default __webpack_public_path__ + "static/media/m_wdt_c_6.9c1d9cc9.mp3";